import { render } from "./MediaLib.vue?vue&type=template&id=9cd3791e"
import script from "./MediaLib.vue?vue&type=script&lang=ts"
export * from "./MediaLib.vue?vue&type=script&lang=ts"

import "./MediaLib.vue?vue&type=style&index=0&id=9cd3791e&lang=scss"
script.render = render

export default script